import React from 'react';
import PropTypes from 'prop-types';
import FilterOperatorModel from '../../../../models/pipeline/steps/dataset/filter_operator';
import {GROUPS} from "../../../../models/pipeline/steps/dataset/filter_types";
import {
    filterOperatorHoverEvent, filterOperatorLeaveEvent,
    filterOperatorSelectEvent,
    inputSubmitEvent
} from '../../../../services/query_builder_events';
import AttributeMenu from './attribute_menu';
import {queryBuilderState} from "../../../../services/query_builder_state";


export default class FilterOperatorSelector extends AttributeMenu {
    constructor(props) {
        super(props);
        const groups = GROUPS[queryBuilderState.attribute.column.type];
        Object.assign(
            this.state,
            {
                groups,
                selectedOperator: groups[0].items[0],
                selectedOperatorIndex: [0, 0],
            }
        );
    }

    componentDidMount() {
        super.componentDidMount();
        this.unbindInputSubmitEventListener = inputSubmitEvent.listen(() => {
            filterOperatorSelectEvent.emit(this.state.selectedOperator);
        });
        this.unbindFilterOperatorHoverListener = filterOperatorHoverEvent.listen((op) => { this.updateSelectedItem(undefined, op); });
        this.unbindFilterOperatorLeaveListener = filterOperatorLeaveEvent.listen(() => { this.setState({selectedOperator: null}); });
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate();
        const {searchQuery} = this.state;
        const {column} = queryBuilderState.attribute;
        if (prevState.searchQuery !== searchQuery) {
            let groups = GROUPS[column.type];
            if (searchQuery) {
                groups = groups
                    .map(group => (
                        Object.assign(
                            {...group},
                            {items: group.items.filter(operator => operator.isMatch(searchQuery))}
                        )
                    ))
                    .filter(({items}) => items.length);
            }

            if (groups.length === 0) { // typing doesn't match operator
                this.setState({groups, selectedOperator: null, selectedOperatorIndex: null});
            } else {
                this.setState({groups, selectedOperator: groups[0][0], selectedOperatorIndex: [0, 0]});
            }
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.unbindInputSubmitEventListener();
        this.unbindFilterOperatorHoverListener();
        this.unbindFilterOperatorLeaveListener();
    }

    updateSelectedItem(delta, selectedOperator) {
        let {selectedOperatorIndex: [groupIndex, operatorIndex], groups} = this.state;
        if (delta) {
            operatorIndex += delta;
            if (operatorIndex < 0) {
                groupIndex = groupIndex === 0 ? groups.length - 1 : groupIndex - 1;
                operatorIndex = groups[groupIndex].items.length - 1;
            }

            if (operatorIndex >= groups[groupIndex].items.length) {
                groupIndex += 1;
                operatorIndex = 0;
            }
            if (groupIndex >= groups.length) {
                groupIndex = 0;
                operatorIndex = 0;
            }
            selectedOperator = groups[groupIndex].items[operatorIndex];
        } else {
            let found = false;
            for (const [groupNum, group] of groups.entries()) {
                for (const [opNum, operator] of group.items.entries()) {
                    if (operator === selectedOperator) {
                        groupIndex = groupNum;
                        operatorIndex = opNum;
                        found = true;
                        break;
                    }
                }
                if (found) {
                    break;
                }
            }
        }
        this.setState({selectedOperatorIndex: [groupIndex, operatorIndex], selectedOperator});
    }

    renderMenu() {
        const {styles} = this.props;
        const {groups, selectedOperator} = this.state;
        return (
            <div className="filter-menu">
                <h5>Select an Operator</h5>
                <ul className="filter-list w-list-unstyled" style={styles}>
                    {groups.map(group => (
                        <FilterOperatorGroup
                            key={group.heading}
                            group={group}
                            selectedOperator={selectedOperator}
                        />
                    ))}
                </ul>
            </div>
        );
    }
}

FilterOperatorSelector.propTypes = {
    styles: PropTypes.object,
};

FilterOperatorSelector.defaultProps = {
    styles: {},
};


function FilterOperatorGroup({group, onSelect, selectedOperator}) {
    return (
        <>
            <div className="label filter-group-heading">{group.heading}</div>
            {group.items.map(operator => (
                <li
                    key={operator.label}
                    className={`filter-item ${selectedOperator === operator ? 'hover' : ''}`}
                    onClick={() => { filterOperatorSelectEvent.emit(operator); }}
                >
                    <strong>{operator.label}</strong>
                    {operator.sublabel && <span className="filter-item-sublabel">({operator.sublabel})</span>}
                </li>
            ))}
        </>
    );
}

FilterOperatorGroup.propTypes = {
    group: PropTypes.object.isRequired,
    seletectOperator: PropTypes.instanceOf(FilterOperatorModel),
};
